import { OnInit, Component, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { DocumentService } from 'app/shared/services/document.service';
import { MatRadioChange } from '@angular/material';
import { IDtoLawyerCost } from 'app/shared/models/legal/dto-lawyer-cost.model';
import { DemandService } from 'app/views/appviews/demand.service';
import { IDtoDemand } from 'app/shared/models/legal/demand/dto-demand.model';

@Component({
    selector: 'app-modal-demand-cost',
    templateUrl: './modal-demand-cost.template.html',
    styleUrls: ['./modal-demand-cost.style.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ModalDemandCostComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formCost: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Retorno a pantalla padre */

    private fileNameVoucherEvidence: string;
    private fileVoucherEvidence: File;
    private catalogTypeTest: Observable<IDtoCatalog[]>;
    private costs: IDtoLawyerCost[];
    private employeeId: number;
    private catalogLawyers: Observable<IDtoCatalog[]>;
    private catalogAuthorities: Observable<IDtoCatalog[]>;
    private liquidationId: number;
    private settlement: number;
    private demand: IDtoDemand;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private demandService: DemandService
        , private spinner: NgxSpinnerService
        , private datePipe: DatePipe
        , private documentService: DocumentService) {
        this.initializeFormEvidence();
    }
    ngOnInit(): void {
        this.catalogLawyers = this.demandService.getCatalogLawyers();
        this.catalogAuthorities = this.demandService.getCatalogAuthorities();
        this.getDemandByLiquidationId();
        this.patchData();

    }
    private initializeFormEvidence() {
        this.formCost = this.formBuilder.group({
            calculation: [null, [Validators.required]],
            lawyerId: [null, [Validators.required]],
            authorityId: [null, [Validators.required]]
        });
    }
    private getDemandByLiquidationId(): void {
        this.spinner.show()
        this.demandService.getDemandBasicByliquidationId(this.liquidationId)
            .subscribe(
                (x) => {
                    if (x.data != null) {
                        this.demand = x.data as IDtoDemand;
                        this.formCost.patchValue(this.demand);
                        this.formCost.get('calculation').setValue(2);
                        this.getRealCost();
                        //this.patchValueGeneralData();
                    } else {
                        this.configGeneral.newToast('Error', 'No existe una demanda en proceso para esta liquidación', 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private patchData(): void {
        // this.formEvidence.patchValue(this.evidence);
        // if (this.evidence.documentReleaseEvidence) {
        //     this.fileNameVoucherEvidence = this.evidence.documentReleaseEvidence.fileName;
        //     this.formEvidence.get('voucher').setValidators(null);
        //     this.formEvidence.get('voucher').updateValueAndValidity();
        // }
    }

    // private submit(): void {
    //     if (this.formEvidence.valid) {
    //         this.update();
    //     } else {
    //         this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
    //     }
    // }
    private onFileSelectedVoucherEvidence(event) {

        this.fileVoucherEvidence = event.target.files[0];

        if (this.fileVoucherEvidence) {

            this.fileNameVoucherEvidence = this.fileVoucherEvidence.name;
        }
    }
    private getCost(): void {
        this.formCost.value.calculation == 1 ? this.getEstimatedCost() : this.getRealCost();
    }
    private getEstimatedCost(): void {
        if (!this.formCost.valid) {
            this.configGeneral.newToast('Validación', 'Seleccione la información requerida para poder continuar', 'error');
            return;
        } 
        let values = this.formCost.value;
        
        this.spinner.show()
        this.demandService.getEstimatedCostProceduralStagesByAuthorityAndLawyer(values.authorityId, values.lawyerId, this.liquidationId)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.costs = x.data as IDtoLawyerCost[];
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private getRealCost(): void {
        if (!this.formCost.valid) {
            this.configGeneral.newToast('Validación', 'Seleccione la información requerida para poder continuar', 'error');
            return;
        } 
        let values = this.formCost.value;
        
        this.spinner.show()
        this.demandService.getCostProceduralStagesByAuthorityAndLawyer(values.authorityId, values.lawyerId, this.liquidationId)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.costs = x.data as IDtoLawyerCost[];
                        this.formCost.patchValue(this.demand);
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                    this.spinner.hide();
                },
                (errMessage) => {
                    this.spinner.hide();
                    this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
                });
    }
    private onFileChange(event) {
        event.value = '';
    }
    // private resetForm() {
    //     this.formEvidence.reset();
    //     this.fileNameVoucherEvidence = null;
    // }

    private onCancel(): void {
        this.bsModalRef.hide();
    }
}
